module.exports = __webpack_public_path__ + "img/VT.92f3f577.png";